import { render } from "./ProductOptSet.vue?vue&type=template&id=5d779b88"
import script from "./ProductOptSet.vue?vue&type=script&lang=js"
export * from "./ProductOptSet.vue?vue&type=script&lang=js"

import "./ProductOptSet.vue?vue&type=style&index=0&id=5d779b88&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__